<template>
    <div class="uploadFileBtn">
        <div class="file-btn-box">
          <input class="file-btn"
            type="file"
            :id="fileID"
            @change="getFileName"
            multiple="multiplt"
            :accept="acceptFiletype"
            ref="filePath" >
              <!-- <p class="style-word">{{fileLoading==true?'上传中':'上传'}}</p> -->
              <p class="style-word">
                {{fileLoading==true?'上传中':'上传'}}
              </p>
        </div>
    </div>
</template>

<script>
export default {
  name: 'uploadFileBtn',
  props: {
    fileID: String,
    acceptFiletype:{
      type:String,
      default:".docx,.doc,.pdf,.zip",
    },

  },
  components: {

  },
  data () {
    return {
      fileUrl: '' ,// 上传文件路径
      fileLoading:false,
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  methods: {

    // 获取上传的文件名
    getFileName (e) {
      console.log('aaa')
      console.log(document.getElementById(this.fileID).files[0].size,'document.getElementById(this.fileID).files[0]')
      let size = document.getElementById(this.fileID).files[0].size;
      if(size/(1024*1024)>50){
        this.$message.error('文件大小不能超过50M')
        return;
      }
      var fileName = document.getElementById(this.fileID).files[0].name
      this.$emit('getFileNames', fileName)
      this.changeFile()
    },

    // 转换获取文件上传路径
    async changeFile () {
      var filePath = this.$refs.filePath
      var filePahs = filePath.files
      var formData = new FormData()
      formData.append('file', filePahs[0])
      this.fileLoading = true;
      try {
        const res = await this.$post(this.$url.companyInfoManage.upload, formData)
        const { code, msg, data } = res.data

        if (code === 200 && data) {
          this.fileLoading = false;
          this.fileUrl = data.fullUrl
          this.$emit('getFileUrls', this.fileUrl)
        } else {
           this.fileLoading = false;
          this.$message.error(msg)
        }
        this.$refs.filePath.value=null;
      } catch (err) {
        console.log(err)
      }
    }

  }
}
</script>

<style scoped lang="less">
.file-btn-box{
  position: relative;
  width: 48px;
  height: 24px;
  background-color: #EBF3FF;
  border: 1px solid #EBEBEB;
  border-radius: 1px;
  cursor: pointer;
  overflow: hidden;
  .file-btn{
    position: absolute;
    z-index: 10;
    // background-color: rgb(126, 248, 122);
    opacity: 0;
  }
  .style-word{
    // position: absolute;
    // top: 6px;
    // left: 10px;
    color: #3D7FFF;
    text-align: center;
    line-height: 24px;
  }
}

</style>
